{
  "No available actions": "Inga möjliga actions",
  "all-rows-selected": "Alla {{count}} rader valda",
  "table-subselection": "{{count}} rad vald",
  "table-subselection_plural": "{{count}} rader valda",
  "select-all-question": ", vill du <0>Välja alla {{total}} rader?</0>",
  "all-rows-selected_participants": "Alla {{count}} deltagare valda",
  "table-subselection_participants": "{{count}} deltagare vald",
  "table-subselection_participants_plural": "{{count}} deltagare valda",
  "select-all-question_participants": ", vill du <0>välja alla {{total}} deltagare?</0>"
}
